// Header: mobile menu, dropdowns opened by click or keyboard (hover is CSS
// only), and a shadow once the page is scrolled.
export default function siteNav() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const menuButton = header.querySelector('.site-header__menu');
  const toggles = header.querySelectorAll('.site-nav__toggle');

  const closeSubmenus = (except) => {
    toggles.forEach((toggle) => {
      if (toggle !== except) toggle.setAttribute('aria-expanded', 'false');
    });
  };

  const setMenuOpen = (open) => {
    menuButton.setAttribute('aria-expanded', String(open));
    header.classList.toggle('is-menu-open', open);
    document.documentElement.classList.toggle('no-scroll', open);
    if (open) {
      // The panel comes before the button in the DOM; start keyboard users in it.
      header.querySelector('.site-nav__link').focus();
    } else {
      closeSubmenus();
    }
  };

  menuButton.addEventListener('click', () => {
    setMenuOpen(menuButton.getAttribute('aria-expanded') !== 'true');
  });

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeSubmenus(toggle);
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openToggle = header.querySelector('.site-nav__toggle[aria-expanded="true"]');
    if (openToggle) {
      closeSubmenus();
      openToggle.focus();
    } else if (header.classList.contains('is-menu-open')) {
      setMenuOpen(false);
      menuButton.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) closeSubmenus();
  });

  // The menu panel is position: fixed under the header; close it when the
  // viewport grows past the desktop breakpoint.
  window.matchMedia('(min-width: 1080px)').addEventListener('change', (event) => {
    if (event.matches) setMenuOpen(false);
  });

  const sentinel = document.querySelector('.privacy-sentinel');
  if (sentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      header.classList.toggle('is-scrolled', !entry.isIntersecting);
    }).observe(sentinel);
  }
}
